import React from 'react';
import BorderlessContainer from 'talent_matching/components/shared/borderless_container';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { Link } from '@grnhse/seedling/lib/birch/typography';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';
import PreviewIcon from '@grnhse/seedling/lib/birch/icons/preview';
import LinkedinIcon from 'talent_matching/components/icons/linkedin_icon';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching');

type Props = {
  linkedinAddress?: string | null;
  onViewLinkedin?: () => void;
};

const LinkedinActivitySection = ({
  linkedinAddress,
  onViewLinkedin,
}: Props) => {
  const handleViewLinkedinClick = (e: React.SyntheticEvent) => {
    if (onViewLinkedin) {
      e.preventDefault();
      onViewLinkedin();
    }
  };

  return (
    <BorderlessContainer filled>
      <Stack spacing={1} sx={{ paddingX: 1 }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <LinkedinIcon />
          <Stack direction="row" spacing={2}>
            <Link
              onClick={handleViewLinkedinClick}
              style={{ cursor: 'pointer' }}
            >
              {t('linkedin_activity.view_via_linkedin')}
            </Link>
            {linkedinAddress && (
              <Stack direction="row" spacing={0.5} alignItems="center">
                <Link href={linkedinAddress} target="_blank">
                  {t('linkedin_activity.open_public_profile')}
                </Link>
                <PreviewIcon size="sm" color={FullPalette.GREEN_700} />
              </Stack>
            )}
          </Stack>
        </Stack>
      </Stack>
    </BorderlessContainer>
  );
};

export default LinkedinActivitySection;
